import { gql } from "@apollo/client";


export const GET_PROFESIONALES_PARA_LIQUIDAR = gql`
    query profesionalesParaLiquidar($idTipoProfesional: Int!, $idDelegacion: Int!, $mes: Int!, $anio: Int!, $idEstado: Int!, $liquidacionFinal: Boolean!) {
        profesionalesParaLiquidar(idTipoProfesional: $idTipoProfesional, idDelegacion: $idDelegacion, mes: $mes, anio: $anio, idEstado: $idEstado, liquidacionFinal: $liquidacionFinal) {
            idProfesional
            nombre
            apellido
            idTipoDocumentoNavigation { descripcion }
            numeroDoc
        }
    }
`;

export const adaptProfesionalLiquidar = (p) => ({
  id:            p.idProfesional,
  nombre:        p.nombre,
  apellido:      p.apellido,
  tipoDocumento: p.idTipoDocumentoNavigation?.descripcion ?? '-',
  numeroDoc:     p.numeroDoc ?? '-',
});

export const adaptProfesionalesParaLiquidarArray = (data) =>
  structuredClone(data?.profesionalesParaLiquidar)?.map(adaptProfesionalLiquidar) ?? [];
